module.exports = __webpack_public_path__ + "img/S10.87e23839.svg";